export default "__VITE_ASSET__7a6185a0__"